/* nb-cmax-refills.js
   Flip toggle for the refills cards: [data-nb-refills-card] holds two faces
   ([data-nb-refills-flip] triggers on each face flip it back). Scoped to this
   page's cards only; not a shared nb-ui.js module since no other page uses a
   flip card today (BUILD-CONVENTIONS: page behaviour stays under the page
   prefix until a second page needs it, per the registry's "not in the
   registry" rule).
*/
(function () {
  function toggle(card) {
    var flipped = card.getAttribute('data-nb-flipped') === 'true';
    var next = !flipped;
    card.setAttribute('data-nb-flipped', String(next));
    var front = card.querySelector('.nb-cmax-refills__face--front');
    var back = card.querySelector('.nb-cmax-refills__face--back');
    var triggers = card.querySelectorAll('[data-nb-refills-flip]');
    if (next) {
      front.setAttribute('hidden', '');
      back.removeAttribute('hidden');
      var loop = back.querySelector('[data-nb-refills-loop]');
      if (loop && !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches)) { try { loop.currentTime = 0; var pr = loop.play(); if (pr && pr.catch) pr.catch(function () {}); } catch (e) {} }
    } else {
      back.setAttribute('hidden', '');
      var loopOff = back.querySelector('[data-nb-refills-loop]');
      if (loopOff) { try { loopOff.pause(); } catch (e) {} }
      front.removeAttribute('hidden');
    }
    triggers.forEach(function (t) {
      t.setAttribute('aria-pressed', String(next));
    });
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-nb-refills-flip]');
    if (!trigger) return;
    var card = trigger.closest('[data-nb-refills-card]');
    if (!card) return;
    e.preventDefault();
    toggle(card);
  });
})();
